"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const lodash_1 = require("lodash");
const react_redux_1 = require("react-redux");
const MenuItem_1 = __importDefault(require("@mui/material/MenuItem"));
const HelpOutline_1 = __importDefault(require("@mui/icons-material/HelpOutline"));
const core_1 = require("companion-app-components/utils/core");
const feature_flags_1 = require("companion-app-components/flux/feature-flags");
const MainNavItem_1 = require("containers/App/Header/MainNavItem");
const useQPreferences_1 = __importDefault(require("components/QPreferences/useQPreferences"));
const actions_1 = require("components/Dialogs/WhatsNew/actions");
const actions_2 = require("components/Dialogs/ReleaseNotes/actions");
const actions_3 = require("components/Dialogs/HelpSupportDialog/actions");
const selectors_1 = require("companion-app-components/flux/preferences/selectors");
const selectors_2 = require("data/accountNodes/selectors");
const constants_1 = require("utils/constants");
const utils_1 = require("../utils");
const currentVersion = process.env.APP_VERSION;
let whatsNewData;
try {
    // eslint-disable-next-line
    whatsNewData = require(`/static/whats-new${currentVersion}/WhatsNew.json`);
    if ((whatsNewData === null || whatsNewData === void 0 ? void 0 : whatsNewData.version) === currentVersion) {
        whatsNewData = {
            count: whatsNewData.pages,
            pages: whatsNewData.order.split(','),
        };
    }
}
catch (_a) {
    whatsNewData = {};
}
const HelpSupportButton = ({ classes, selected, iconSize, settingsPageNavRef, canOpenSubMenu, closeHeader, handleTracking, }) => {
    var _a;
    const dispatch = (0, react_redux_1.useDispatch)();
    const hasWhatsNewJSON = ((_a = whatsNewData === null || whatsNewData === void 0 ? void 0 : whatsNewData.pages) === null || _a === void 0 ? void 0 : _a.length) > 0;
    const { userPreferences, setUserPreference } = (0, useQPreferences_1.default)();
    const isUserPrefLoading = (0, react_redux_1.useSelector)(selectors_1.getLoadPendingState).shared.user;
    // TODO: type assigning wont be needed once new app-component is installed
    const accountNodesTree = (0, react_redux_1.useSelector)(selectors_2.getAccountNodesTree);
    const showReleaseNotes = (0, react_redux_1.useSelector)((state) => feature_flags_1.featureFlagsSelectors.getFeatureFlag(state, 'showReleaseNotes'));
    const dispatchShowWhatsNewDialog = () => dispatch((0, actions_1.showWhatsNewDialog)(whatsNewData, () => dispatch((0, actions_2.showReleaseNotesDialog)())));
    const dispatchShowReleaseNotesDialog = () => dispatch((0, actions_2.showReleaseNotesDialog)());
    const handleItemClick = (menuItemClicked) => {
        closeHeader();
        const objMenuItemHandlers = {
            whatsNew: dispatchShowWhatsNewDialog,
            releaseNotes: dispatchShowReleaseNotesDialog,
            supportFAQ: () => dispatch((0, actions_3.doHelpSupportModal)()),
        };
        if (!objMenuItemHandlers[menuItemClicked]) {
            return;
        }
        objMenuItemHandlers[menuItemClicked]();
        core_1.tracker.track(core_1.tracker.events[menuItemClicked]);
    };
    React.useEffect(() => {
        const debounceDialogTrigger = (0, lodash_1.debounce)(() => {
            (0, utils_1.checkAndTriggerWhatsNewDialog)({
                isUserPrefLoading,
                userPreferences,
                setUserPreference,
                currentVersion,
                hasWhatsNewJSON,
                showReleaseNotes,
                dispatchShowReleaseNotesDialog,
                dispatchShowWhatsNewDialog,
            });
        }, 2000);
        const triggerDebounce = () => {
            debounceDialogTrigger();
        };
        if (accountNodesTree.size > 0) {
            triggerDebounce();
        }
        return debounceDialogTrigger.cancel;
    }, [isUserPrefLoading, userPreferences === null || userPreferences === void 0 ? void 0 : userPreferences.whatsNewViewed, accountNodesTree.size]); // eslint-disable-line react-hooks/exhaustive-deps
    return (<MainNavItem_1.MainNavItem disableClick key="nav-item-help" nav={{
            path: '/help',
            component: null,
            nav: 'main',
            title: 'Help',
            alt: 'contains various Help menu items',
            img: HelpOutline_1.default,
            subMenuItems: [...constants_1.HELP_MENU_ITEMS],
        }} selected={selected} classes={classes} canOpenSubMenu={canOpenSubMenu} iconSize={iconSize} iconRef={settingsPageNavRef} closeHeader={closeHeader} handleTracking={handleTracking} renderSubMenuItems={constants_1.HELP_MENU_ITEMS.map(({ key, label }) => (<MenuItem_1.default key={key} onClick={() => handleItemClick(key)} disabled={!hasWhatsNewJSON && key === 'whatsNew'}>
          {label}
        </MenuItem_1.default>))}/>);
};
exports.default = HelpSupportButton;
